import React, { Component } from 'react'
import history from '../../../history';
import axios from 'axios'
import UserProfile from '../../UserProfile'
import Select from "react-select";
import authHeader from '../../authentication/authHeader'
import AuthService from '../../authentication/AuthService'
import ReactTooltip from 'react-tooltip';
import { RequiredTitle } from '../../utils/Util'
import SimpleReactValidator from 'simple-react-validator';
import ocsvalidators, { messages, errorMessageClassName } from '../../utils/ocsvalidators'

class ClinicServiceTypeEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            servicetypesId: '',
            serviceTypeList: [],
            servicetypeId: '',
            skillList: [],
            skillsId: '',
            clinicId: '',
            sequence: '',
            errors: [],
            multiValue: [],
            activeStatus: 'Y',
            maxservicetypesId: '',
            createdBy: '',
            createdDate: ''
        }
        this.setFocus = React.createRef();
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: errorMessageClassName,
            validators: ocsvalidators,
            messages: messages
        });
        this.handleMultiChange = this.handleMultiChange.bind(this);
    }
    componentDidMount() {
        axios.get('/clinicserviceTypes', { headers: authHeader() })
            .then(response1 => {
                axios.get('/activeservicetypeslist', { headers: authHeader() })
                    .then(response2 => {
                        var codesetitemid = this.props.match.params
                        var id = codesetitemid.servicetypesId.replace(":", "")
                        axios.get('/clinicserviceTypes/' + id, { headers: authHeader() })
                            .then(response3 => {
                                axios.get('/skillslist', { headers: authHeader() })
                                    .then(response4 => {
                                        this.setState({
                                            maxservicetypesId: Math.max.apply(Math, response1.data.map(function (o) { return o.servicetypesId + 1; })),
                                            serviceTypeList: response2.data,
                                            serviceTypeList: response2.data,
                                            servicetypesId: response3.data[0][0], clinicId: response3.data[0][1], servicetypeId: response3.data[0][2],
                                            skillsId: response3.data[0][3], sequence: response3.data[0][4],
                                            activeStatus: response3.data[0][5],
                                            skillList: response4.data,
                                            clinicId: UserProfile.getClinicId(),
                                            multiValue: response3.data[0][3].split(',').map((sk) => {
                                                return ({
                                                    value: sk.substr(0, sk.indexOf(":")),
                                                    label: sk.substr(sk.indexOf(":") + 1, sk.length),
                                                })
                                            })
                                        })
                                    })
                                    .catch(function (error) {
                                        console.log('response4 : ', error);
                                        history.push('/Errorpage')
                                    })
                            })
                            .catch(function (error) {
                                console.log('response3 : ', error);
                                history.push('/Errorpage')
                            })
                    })
                    .catch(function (error) {
                        console.log('response2 : ', error);
                        history.push('/Errorpage')
                    })
            })
            .catch(function (error) {
                console.log('response1 : ', error);
                history.push('/Errorpage')
            })
        this.setFocus.current.focus();
    }

    addClinicServiceTypeEdit = (event) => {
        event.preventDefault();
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            return;
        }

        const skillValues = this.state.multiValue.map(d => { return (d.label) })

        if (Object.values(this.state.multiValue).length == 0) {
            document.getElementById('skills').style.borderColor = "red";
        }

        var index1 = this.state.maxservicetypesId
        let updateClinicserviceTypesList = []
        for (let index = 0; index < this.state.multiValue.length; index++) {
            const element = this.state.multiValue[index];
            let d = {
                servicetypesId: index1,
                clinicId: this.state.clinicId, servicetypeId: this.state.servicetypeId, skillsId: Object.values(element)[0], sequence: this.state.sequence,
                activeStatus: this.state.activeStatus, deletedYN: 'N', createdBy: AuthService.getCurrentUserName(),
                lastUpdatedBy: AuthService.getCurrentUserName()
            }

            updateClinicserviceTypesList.push(d)
            index1 = index1 + 1
        }

        axios.delete('/deleteclinicserviceTypes/' + this.state.servicetypesId, { headers: authHeader() })
            .then(response => {
                axios.post('/updateclinicserviceTypes', updateClinicserviceTypesList, { headers: authHeader() })
                    .then(response => {
                        UserProfile.setHighlights([response.data.map((e) => e.servicetypesId).join()], 'success')
                        history.push('/clinic/' + UserProfile.getClinicId() + '/5');
                    })
                    .catch(function (error) {
                        console.log(error);
                        history.push('/Errorpage')
                    })
            })
            .catch(function (error) {
                console.log(error);
                history.push('/Errorpage')
            })
    }
    cancelClinicServiceTypeEdit = (event) => {
        event.preventDefault();
        var codesetitemid = this.props.match.params
        UserProfile.setHighlights([codesetitemid.servicetypesId.replace(":", "")], 'info')
        history.push('/clinic/' + UserProfile.getClinicId() + '/5');
    }
    handleChange = (event) => {
        const target = event.target;
        const field = target.name;
        const value = target.value

        this.setState({
            [field]: value
        });
    }
    handleChangeForResource = (event) => {
        let d = [null]
        if (parseInt(event.target.value) > 0) {
            d = this.state.resourceList.filter(resource => resource.codesetItemId == event.target.value).map((x, i) => { return x.resourceTypeId })
        }
        this.setState({
            [event.target.name]: event.target.value,
            resourceTypeId: d[0]
        });
    }
    handleMultiChange(option) {
        this.setState(state => {
            return {
                multiValue: option
            };
        });
    }
    handleChangeForSkill = (event) => {
        const target = event.target;
        const field = target.name;
        const value = target.value

        let value1 = Array.from(event.target.selectedOptions, option => option.value);
        this.setState({ values: value1 });
    }
    render() {
        let serviceTypeListnew = this.state.serviceTypeList.length > 0
            && this.state.serviceTypeList.map((serviceType, i) => {
                return (
                    <option key={i} value={serviceType.codesetItemId}>{serviceType.name}</option>
                )
            }, this);

        let skillListnew = this.state.skillList.length > 0
            && this.state.skillList.map((skill, i) => {
                return ({
                    value: skill.codesetItemId,
                    label: skill.name
                }
                )
            }, this);
        return (
            <div className="container-fluid">
                <div className="section-title">
                    <h4>Edit Service Type</h4>
                </div>
                <RequiredTitle />
                <div className="section-title containerAdd">
                    <table className="table table-striped table-bordered">
                        <thead className="thead-dark">
                        </thead>
                        <tbody>
                            <tr>
                                <td className="col-auto"><b>Clinic Name</b></td>
                                <td className="col-auto"><b>{UserProfile.getClinicName()}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>Service Type<span className='text-danger ml-1'>*</span></td>
                                <td className="form-inline">
                                    <select className="form-control mr-sm-1" value={this.state.servicetypeId} name="servicetypeId" id="servicetypeId" onChange={this.handleChangeForResource}
                                        ref={this.setFocus}>
                                        <option value="0">-- Select Service Type  --</option>
                                        {serviceTypeListnew}
                                    </select>
                                    {this.validator.message('servicetypeId', this.state.servicetypeId, 'required|not_in:0')}
                                </td>
                            </tr>
                            <tr>
                                <td>Skills<span className='text-danger ml-1'>*</span></td>
                                <td>
                                    <small className="form-text">If multiple skills are selected, those will be used in the selected order during GFF</small>
                                    <Select
                                        name="skills"
                                        placeholder="skills"
                                        closeMenuOnSelect={false}
                                        value={this.state.multiValue}
                                        options={skillListnew}
                                        onChange={this.handleMultiChange}
                                        isMulti
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        id="skills"
                                    />
                                    {this.validator.message('multiValue', this.state.multiValue, 'required')}
                                </td>
                            </tr>
                            <tr>
                                <td className="col-auto">Sequence<span className='text-danger ml-1'>*</span></td>
                                <td className="col-auto"><input type="text"
                                    name="sequence"
                                    value={this.state.sequence}
                                    onChange={this.handleChange}
                                    id="sequence" className="col-lg-2 form-control" placeholder="1" maxLength="3" />
                                    {this.validator.message('Display Order', this.state.sequence, 'required|numeric|min:0,num|numeric|max:99999,num')}
                                </td>
                            </tr>
                            <tr>
                                <td>Active?<span className='text-danger ml-1'>*</span></td>
                                <td className="form-inline">
                                    <div className="form-group mx-sm-1 mb-1">
                                        <input className="form-check-input" type="radio" name="activeStatus" id="yes" value="Y" checked={this.state.activeStatus === "Y"} onChange={this.handleChange} />
                                        <label className="form-check-label" htmlFor="yes">Yes</label>
                                    </div>

                                    <div className="form-group mx-sm-4 mb-1 mx-lg-3">
                                        <input className="form-check-input" type="radio" name="activeStatus" id="no" value="N" checked={this.state.activeStatus === "N"} onChange={this.handleChange} />
                                        <label className="form-check-label" htmlFor="no">No</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <ReactTooltip />
                                    <button type="button" onClick={this.addClinicServiceTypeEdit} className="btn btn-primary" data-tip="Save">Save</button>&nbsp;
                                    <button type="button" onClick={this.cancelClinicServiceTypeEdit} className="btn btn-secondary" data-tip="Cancel">Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default ClinicServiceTypeEdit
